import {
  Route,
  Redirect,
} from "react-router-dom";

interface propTypes {
  children?: React.ReactNode,
  key: any,
  path: string,
  statusSession: any,
  exact : boolean,
  layout: React.ElementType<any>,
  component: React.ElementType<any>,
}

const CustomRoute = (props: propTypes ) => {

  const { component: Component, statusSession } = props

  if (statusSession.loggedIn) {
      return (
        <Route exact={props.exact} path={props.path}>
          <Component/>
        </Route>
      )
  } else {
      return <Redirect to={{ pathname: "/login" }} />
  }
}

export default CustomRoute
